var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'resetPassword')?_c('handle-password-reset',{attrs:{"code":_vm.code}}):(_vm.mode === 'verifyEmail' || 'handleVerifyEmail')?_c('handle-verify-email',{attrs:{"code":_vm.code,"success-token":_vm.successToken}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }